/** @jsxImportSource @emotion/react */
import CloseIcon from '@mui/icons-material/Close';
import { Backdrop, css, IconButton } from "@mui/material";
import { withMyTheme } from '../../theme/theme';
import { FEATURES_BASE_URL } from './Features';
import { HAMBURGER_Z_INDEX } from '../../navigation/NavigationMobile';

const ExpandedScreenStyle = withMyTheme((theme) => css`
  width: 90vw !important;
  height: 90vh !important;
  position: fixed;
  z-index: 1003;
  background-color: white;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  overflow: hidden;
`);

const ExpandedScreenContentStyle = withMyTheme(() => css`
  width: 100%;
  height: 100%;
  overflow: auto;
`);

const ExpandedWebsiteIframeStyle = withMyTheme(() => css`
  width: 100%;
  height: 100%;
  border: none;
`);

const ExpandedControlsStyle = withMyTheme((theme) => css`
  position: absolute;
  top: 10px;
  right: 10px;
  display: flex;
  gap: 8px;
  z-index: 1005;
  
  .MuiIconButton-root {
    background-color: rgba(255, 255, 255, 0.9);
    color: ${theme.palette.primary.main};
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.15);
    
    &:hover {
      background-color: rgba(255, 255, 255, 1);
    }
  }
`);

const BackdropStyle = withMyTheme(() => css`
  z-index: 1002;
  background-color: rgba(0, 0, 0, 0.7);
`);

export const ExpandedIframeView = ({ isExpanded, handleCloseExpanded, expandedIframeRef }: { isExpanded: boolean, handleCloseExpanded: () => void, expandedIframeRef: React.RefObject<HTMLIFrameElement | null>}) => {
    return (
        <Backdrop
            open={isExpanded} css={BackdropStyle} onClick={handleCloseExpanded}
            transitionDuration={350}
        >
            <div css={ExpandedScreenStyle} onClick={(e) => e.stopPropagation()}>
                <div css={ExpandedScreenContentStyle}>
                    <iframe
                        ref={expandedIframeRef}
                        src={FEATURES_BASE_URL}
                        title="Wedding website preview expanded"
                        css={ExpandedWebsiteIframeStyle}
                        loading="lazy"
                    />
                </div>
                <div css={ExpandedControlsStyle}>
                    <IconButton onClick={handleCloseExpanded} aria-label="Close">
                        <CloseIcon />
                    </IconButton>
                </div>
            </div>
        </Backdrop>
    );
}